function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import './StickyCards.css';
import React from 'react';
import { useSitecoreContext } from '../../../utils/SitecoreContextReactContext';
import { get } from '../../../utils';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import RouterLink from '../../atoms/RouterLink';
import { tealiumClickFunc, tealiumMergeClickNewData } from '../../../utils/tealium';
import { convertToAnalyticObject } from '../../../utils/analytics';
import ScrollAnimation from 'react-animate-on-scroll';
import CarouselProvider from '../../atoms/CarouselProvider/CarouselProvider';
import { css } from 'linaria';
import { isNotNil } from '../../../utils/IsNil';
const Cards = _ref => {
  let {
    item,
    itemsLength,
    eventsAnalytics,
    params
  } = _ref;
  const cardIconSrc = get(item, 'cardIcon.jss.value.src');
  const svgIcon = get(item, 'cardIconCode.jss.value');
  const cardIconAlt = get(item, 'cardIcon.jss.value.alt');
  const hasTitle = Boolean(get(item, 'title.jss.value'));
  const cardTitle = get(item, 'title.jss.value');
  const BASE_URL = String(process.env.REACT_APP_MEDIA_HOST || '');
  if (!itemsLength) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "cardMaxHeight"
  }, hasTitle && /*#__PURE__*/React.createElement("div", {
    className: "card--item__icon cardMaxHeight",
    "data-cy": "general-card-icon"
  }, /*#__PURE__*/React.createElement("div", {
    className: `${itemsLength >= 5 ? "card-box-carousel" : "card-box"} theme-contrast cardMaxHeight`
  }, /*#__PURE__*/React.createElement("div", {
    className: `${itemsLength >= 5 ? "iconCircleColorInCarousel" : "iconCircleColorWithoutCarousel"} iconCircle`
  }, isNotNil(svgIcon) && svgIcon.includes("svg") ? /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: svgIcon
    },
    className: "h__icon"
  }) : /*#__PURE__*/React.createElement("img", {
    className: "h__icon",
    src: BASE_URL + cardIconSrc,
    alt: cardIconAlt
  })), hasTitle ? item.ctaLink.jss.value.href ? /*#__PURE__*/React.createElement(RouterLink, {
    className: "cardTitleLink",
    onClick: () => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['titleClickAnalytics'], params), cardTitle),
    href: item.ctaLink.jss.value.href
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "h__title body-large cardTitle",
    field: item.title && item.title.jss
  })) : /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "h__title body-large cardTitle",
    field: item.title && item.title.jss
  }) : null)));
};
const StickyCards = _ref2 => {
  let {
    fields,
    params
  } = _ref2;
  const sitecoreContext = useSitecoreContext();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const isDetSite = get(params, 'RenderingStyle') === 'DDA' || false;
  const defaultCardsHasTitle = Boolean(get(fields, 'data.item.title.jss.value'));
  const defaultCardsHasDescription = Boolean(get(fields, 'data.item.description.jss.value'));
  const childrenItems = get(fields, 'data.item.children', []);
  const ctaLabel = get(fields, 'data.item.ctaLabel.jss.value');
  const ctaLink = get(fields, 'data.item.ctaLink.jss.value.href');
  const ctaLinktype = get(fields, 'data.item.ctaLink.jss.value.linktype');
  const ctaLeftIcon = get(fields, 'data.item.ctaLeftIcon.targetItem.svg.jss.value');
  const ctaRightIcon = get(fields, 'data.item.ctaRightIcon.targetItem.svg.jss.value');
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const items = childrenItems.length ? childrenItems.filter(item => item.title) : [];
  const classItemsContainerMap = {
    2: "twoItemsContainer",
    3: "threeItemsContainer",
    4: "fourItemsContainer"
  };
  const classItemWidthMap = {
    2: "twoItemWidth",
    3: "threeItemWidth",
    4: "fourItemWidth"
  };

  // old code, unused
  const cardsProps = {
    params: {
      eventCat: params.eventCat,
      eventName: params.eventName,
      eventAct: params.eventAct,
      ColorHex: params.ColorHex,
      BackgroundColorHex: params.BackgroundColorHex
    }
  };
  const renderItems = () => {
    return items.map((item, index) => /*#__PURE__*/React.createElement(ScrollAnimation, {
      className: classItemWidthMap[items.length],
      animateIn: "animate__fadeInUp",
      animateOnce: true,
      duration: 1 + index / 3,
      key: item.id
    }, /*#__PURE__*/React.createElement(Cards, _extends({}, cardsProps, {
      item: item,
      itemsLength: items.length,
      eventsAnalytics: eventsAnalytics
    }))));
  };
  const renderItems04 = () => {
    if (items.length <= 1) {
      console.warn(`provided ${items.length} card but requires 2 or more cards`);
      return;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: classItemsContainerMap[items.length]
    }, renderItems());
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    className: "M07_sticky",
    isDetSite: isDetSite
  }, defaultCardsHasTitle && items.length < 5 ? /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    className: "h3 h__title componentTitle",
    field: fields.data.item.title.jss
  }) : null, defaultCardsHasDescription && items.length < 5 ? /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "h__desc",
    field: fields.data.item.description.jss
  }) : null, items.length < 5 ? renderItems04() : null, items.length >= 5 ? /*#__PURE__*/React.createElement(CarouselProvider, null, _ref3 => {
    let {
      renderCarousel,
      renderPreviousButton,
      renderNextButton,
      renderDots
    } = _ref3;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "card__head"
    }, /*#__PURE__*/React.createElement("div", null, defaultCardsHasTitle ? /*#__PURE__*/React.createElement("div", {
      className: "h__txt"
    }, defaultCardsHasTitle ? /*#__PURE__*/React.createElement(Text, {
      tag: "h3",
      className: "h3 h__title componentTitle",
      field: fields.data.item.title.jss
    }) : null) : null, defaultCardsHasDescription ? /*#__PURE__*/React.createElement(Text, {
      tag: "p",
      className: "h__desc",
      field: fields.data.item.description.jss
    }) : null), isDetSite && /*#__PURE__*/React.createElement("div", {
      className: `pagination__btn ${rtl ? 'btn-group-rtl' : ''}`
    }, renderPreviousButton(() => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['nextPrevAnalytics'], params), ['previous']), false, false, null, isDetSite), renderNextButton(() => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['nextPrevAnalytics'], params), ['next']), false, false, null, isDetSite))), /*#__PURE__*/React.createElement("div", {
      className: "card-container__inner"
    }, !isDetSite && /*#__PURE__*/React.createElement("div", {
      className: `pagination__btn ${rtl ? 'btn-group-rtl' : ''}`
    }, renderPreviousButton(() => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['nextPrevAnalytics'], params), ['previous']), false, false, null, isDetSite), renderNextButton(() => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['nextPrevAnalytics'], params), ['next']), false, false, null, isDetSite)), renderCarousel(renderItems(), {
      responsive: {
        extra: {
          breakpoint: {
            max: 10000,
            min: 1441
          },
          items: 4
        },
        desktop: {
          breakpoint: {
            max: 1440,
            min: 901
          },
          items: 3
        },
        mobile: {
          breakpoint: {
            max: 900,
            min: 0
          },
          items: 2
        }
      },
      containerClass: "carouselContainer"
    })), ctaLabel && ctaLink ? /*#__PURE__*/React.createElement("div", {
      className: "ctaLinkWithPagination"
    }, ctaLabel && ctaLink && /*#__PURE__*/React.createElement(RouterLink, {
      className: `btn ${isDetSite ? 'btn-primary' : 'btn-secondary'}`,
      isDetSite: isDetSite,
      href: ctaLink,
      title: ctaLabel,
      linktype: ctaLinktype,
      ctaLeftIcon: ctaLeftIcon,
      ctaRightIcon: ctaRightIcon,
      rtl: rtl,
      colorText: `var(--general-card-icon-theme-text-color)`,
      color: `var(--general-card-icon-color)`,
      colorActive: `var(--general-card-icon-color-active)`
    }, ctaLabel), renderDots(() => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['navigationBubblesAnalytics'], params)), [], isDetSite, 'var(--general-card-icon-color)')) : /*#__PURE__*/React.createElement("div", {
      className: "pagination-dot"
    }, renderDots(() => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['navigationBubblesAnalytics'], params)), [], isDetSite, 'var(--general-card-icon-color)')));
  }) : null);
};
const StyledWrapper = _ref4 => {
  let {
    children,
    rtl,
    className,
    style,
    isDetSite
  } = _ref4;
  const commonStyles = isDetSite ? "cpk3hd6" : "cxiicnv";
  const ltrStyles = isDetSite ? "l1xyuwhh" : "lq2qtwu";
  const rtlStyles = isDetSite ? "rfyti1y" : "r1vzlfso";
  return /*#__PURE__*/React.createElement("div", {
    style: style,
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles} ${className}`
  }, children);
};
const commonStyles = css;
const ltrStyles = css;
const rtlStyles = css;
export { StickyCards };